<template>
    <!-- form -->
    <div class="ya-site-form ya-site-form_inited_no y-search__field" :data-bem="`{&quot;action&quot;:&quot;${origin}/search/&quot;,&quot;arrow&quot;:false,&quot;bg&quot;:&quot;transparent&quot;,&quot;fontsize&quot;:16,&quot;fg&quot;:&quot;#000000&quot;,&quot;language&quot;:&quot;ru&quot;,&quot;logo&quot;:&quot;rb&quot;,&quot;publicname&quot;:&quot;Поиск по ДОМ.РФ&quot;,&quot;suggest&quot;:true,&quot;target&quot;:&quot;_self&quot;,&quot;tld&quot;:&quot;ru&quot;,&quot;type&quot;:2,&quot;usebigdictionary&quot;:false,&quot;searchid&quot;:2914722,&quot;input_fg&quot;:&quot;#000000&quot;,&quot;input_bg&quot;:&quot;#ffffff&quot;,&quot;input_fontStyle&quot;:&quot;normal&quot;,&quot;input_fontWeight&quot;:&quot;normal&quot;,&quot;input_placeholder&quot;:&quot;${placeholder}&quot;,&quot;input_placeholderColor&quot;:&quot;#000000&quot;,&quot;input_borderColor&quot;:&quot;#7f9db9&quot;}`">
        <form action="https://yandex.ru/search/site/" method="get" target="_self" accept-charset="utf-8">
            <input type="hidden" name="searchid" value="2914722"/>
            <input type="hidden" name="l10n" value="ru"/>
            <input type="hidden" name="reqenc" value="utf-8"/>
            <input type="search" name="text" value=""/>
            <input type="submit" value="Искать на сайте"/>
        </form>
    </div>
    <!-- /form -->

    <!-- result -->
    <div id="ya-site-results" ref="results" data-bem="{&quot;tld&quot;: &quot;ru&quot;,&quot;language&quot;: &quot;ru&quot;,&quot;encoding&quot;: &quot;utf-8&quot;,&quot;htmlcss&quot;: &quot;1.x&quot;,&quot;updatehash&quot;: true}"></div>
    <!-- /result -->
</template>

<script>
export default {
    name: 'SearchYandex',
    data() {
        return {
            placeholder: 'Введите поисковый запрос' // искать на сайте
        };
    },
    methods: {
        initForm() {
            (function(w,d,c){var s=d.createElement('script'),h=d.getElementsByTagName('script')[0],e=d.documentElement;if((' '+e.className+' ').indexOf(' ya-page_js_yes ')===-1){e.className+=' ya-page_js_yes';}s.type='text/javascript';s.async=true;s.charset='utf-8';s.src=(d.location.protocol==='https:'?'https:':'http:')+'//site.yandex.net/v2.0/js/all.js';h.parentNode.insertBefore(s,h);(w[c]||(w[c]=[])).push(function(){Ya.Site.Form.init()})})(window,document,'yandex_site_callbacks');
        },
        initRes() {
            (function(w,d,c){var s=d.createElement('script'),h=d.getElementsByTagName('script')[0];s.type='text/javascript';s.async=true;s.charset='utf-8';s.src=(d.location.protocol==='https:'?'https:':'http:')+'//site.yandex.net/v2.0/js/all.js';h.parentNode.insertBefore(s,h);(w[c]||(w[c]=[])).push(function(){Ya.Site.Results.init();})})(window,document,'yandex_site_callbacks');
        },
        insertYaLogo() {
            let el = document.querySelector('.b-pager');
            if (el) {
                let html = '<div aria-label="Поисковая технология Яндекс" class="logo-yandex"><p class="logo-text">Поисковая технология&nbsp;</p><svg xmlns="http://www.w3.org/2000/svg" width="86" height="35" fill="none"><path fill="#000" fill-rule="evenodd" d="M58.87 17.83v1.89h-8.54c.13 2.41 1.13 3.6 3.7 3.6 1.74 0 3.61-.56 4.69-1.28v2.89c-1 .68-2.7 1.18-4.97 1.18-4.53 0-7.1-2.5-7.1-7.63 0-4.5 2.07-7.78 6.39-7.78 3.54 0 5.83 1.95 5.83 7.13zm-5.91-4.32c-1.7 0-2.56 1.24-2.64 3.59h4.93v-.3c0-1.86-.53-3.29-2.3-3.29zM26.24 16.9v-5.93h3.57v14.99h-3.57v-6.27h-4.75v6.27h-3.54v-15h3.54v5.94h4.75zm47.83 9.06h-4.02l-5.25-7.36v7.36h-3.54v-15h3.54v6.93l5-6.92h3.59l-5 6.92 5.68 8.07zm10.48-.75c-.87.63-2.02.93-3.67.93-4.72 0-7.02-2.74-7.03-7.65 0-4.53 2.35-7.75 6.88-7.75 1.76 0 3.07.3 3.82.72v3a6.89 6.89 0 00-3.42-.92c-2.33 0-3.6 1.64-3.6 4.86 0 3.04 1.03 4.94 3.57 4.94 1.49 0 2.55-.4 3.45-1.02v2.9zM44.2 23.15h1.58v6.1H42.5v-3.32h-7.95v3.32h-3.28v-6.11h1.1c1.25-2.5 1.5-7.24 1.5-10.9v-1.28H44.2v12.19zm-8.54 0h5v-9.38h-3.75v.44c0 2.59-.26 6.68-1.25 8.94z" clip-rule="evenodd"/><path fill="#FC3F1D" d="M14.97 25.95V5.25H9.73c-5.28 0-8.04 2.7-8.04 6.7 0 3.17 1.51 5.07 4.22 7l-4.71 7h3.9l5.25-7.85-1.82-1.21c-2.2-1.5-3.29-2.65-3.29-5.16 0-2.2 1.55-3.69 4.5-3.69h1.61v17.9h3.62z"/></svg></div>';
                el.insertAdjacentHTML('afterend', html);
            }
        },
        initObserver() {
            let elem = this.$refs.results;
            let observer = new MutationObserver(mutations => {

                for(let mutation of mutations) {
                // проверим новые узлы

                for(let node of mutation.addedNodes) {
                    // отслеживаем только узлы-элементы, другие (текстовые) пропускаем
                    if (!(node instanceof HTMLElement)) continue;

                    // или, может быть, пример кода есть в его поддереве?
                    for(let elem of node.querySelectorAll('yass-div[class="b-bottom-wizard"]')) {
                        if (!elem.querySelector('.logo-yandex')) {
                            this.insertYaLogo()
                        }
                    }

                    // или, может быть, пример кода есть в его поддереве?
                        for(let elem of node.querySelectorAll('div')) {
                            if (!elem.classList.contains('b-bottom-wizard')) {
                                let el = document.querySelector('.b-wrapper');
                                if (el && !el.querySelector('.b-bottom-wizard')) {
                                    let html = '<div aria-label="Поисковая технология Яндекс" class="logo-yandex n-mt-3"><p class="logo-text">Поисковая технология&nbsp;</p><svg xmlns="http://www.w3.org/2000/svg" width="86" height="35" fill="none"><path fill="#000" fill-rule="evenodd" d="M58.87 17.83v1.89h-8.54c.13 2.41 1.13 3.6 3.7 3.6 1.74 0 3.61-.56 4.69-1.28v2.89c-1 .68-2.7 1.18-4.97 1.18-4.53 0-7.1-2.5-7.1-7.63 0-4.5 2.07-7.78 6.39-7.78 3.54 0 5.83 1.95 5.83 7.13zm-5.91-4.32c-1.7 0-2.56 1.24-2.64 3.59h4.93v-.3c0-1.86-.53-3.29-2.3-3.29zM26.24 16.9v-5.93h3.57v14.99h-3.57v-6.27h-4.75v6.27h-3.54v-15h3.54v5.94h4.75zm47.83 9.06h-4.02l-5.25-7.36v7.36h-3.54v-15h3.54v6.93l5-6.92h3.59l-5 6.92 5.68 8.07zm10.48-.75c-.87.63-2.02.93-3.67.93-4.72 0-7.02-2.74-7.03-7.65 0-4.53 2.35-7.75 6.88-7.75 1.76 0 3.07.3 3.82.72v3a6.89 6.89 0 00-3.42-.92c-2.33 0-3.6 1.64-3.6 4.86 0 3.04 1.03 4.94 3.57 4.94 1.49 0 2.55-.4 3.45-1.02v2.9zM44.2 23.15h1.58v6.1H42.5v-3.32h-7.95v3.32h-3.28v-6.11h1.1c1.25-2.5 1.5-7.24 1.5-10.9v-1.28H44.2v12.19zm-8.54 0h5v-9.38h-3.75v.44c0 2.59-.26 6.68-1.25 8.94z" clip-rule="evenodd"/><path fill="#FC3F1D" d="M14.97 25.95V5.25H9.73c-5.28 0-8.04 2.7-8.04 6.7 0 3.17 1.51 5.07 4.22 7l-4.71 7h3.9l5.25-7.85-1.82-1.21c-2.2-1.5-3.29-2.65-3.29-5.16 0-2.2 1.55-3.69 4.5-3.69h1.61v17.9h3.62z"/></svg></div>';
                                    el.insertAdjacentHTML('afterend', html);
                                }
                            }
                    }
                }
            }
            });

            observer.observe(elem, {
                childList: true,
                subtree: true
            });
        }
    },
    computed: {
        origin() {
            return window.location.origin;
        },
    },
    mounted() {
        this.initForm();
        this.initRes();
        this.initObserver();
    }
}
</script>
